import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight, Gift, Heart, Sparkles } from "lucide-react";
const Hero = () => {
  return <section className="bg-gradient-soft py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-serif font-semibold text-foreground mb-6 leading-tight">
            <span className="text-primary block"> Pour lui dire je t'aime,</span>
            <span className="text-warm-brown">une fois par mois</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground mb-12 leading-relaxed">
            Offrez une box d'activités personnalisées à vos grands-parents,
            <br className="hidden md:block" />
            livrée directement chez eux.
          </p>

          {/* Section avec image et texte */}
          <div className="grid md:grid-cols-2 gap-8 mb-8 items-center">
            <div className="text-left">
              <h2 className="text-3xl md:text-4xl font-serif font-semibold text-foreground mb-4">
                Un abonnement pour une activité par mois
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed mb-6">
                Offrez une activité par mois à vos grands-parents pour qu'ils pensent à vous et qu'ils aient, tous les mois, une activité de votre part.
              </p>
              <p className="text-lg text-muted-foreground font-medium">
                Garder une activité physique, mentale et social permet d'améliorer la santé et réduire le vieillissement !
              </p>
            </div>
            <div className="relative">
              <img 
                src="/lovable-uploads/6d47cf96-410c-4861-98e0-c918c5b9a53e.png" 
                alt="Grands-parents recevant des cadeaux" 
                className="w-full h-auto rounded-2xl shadow-warm"
                fetchPriority="high"
                width="432"
                height="361"
                style={{ maxWidth: "432px", height: "auto" }}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 432px"
              />
            </div>
          </div>

          {/* Comment ça marche */}
          <div className="mb-16">
            <Card className="p-8 shadow-warm border-2 border-primary/20">
              <h3 className="text-2xl font-serif font-semibold mb-8 text-center text-foreground">
                Comment ça marche
              </h3>
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-white font-bold text-lg">1</span>
                  </div>
                  <h4 className="text-2xl font-bold mb-3 text-black">Choisir les activités</h4>
                  <p className="text-green-600 font-medium h-16 flex items-start justify-center pt-4">En fonction des goûts et capacités de votre ainé pour lui offrir des moments de bonheur adapté</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-white font-bold text-lg">2</span>
                  </div>
                  <h4 className="text-2xl font-bold mb-3 text-black">Souscrire à un abonnement</h4>
                  <p className="text-green-600 font-medium h-16 flex items-center justify-center">Pour une livraison mensuelle automatique qui créera de l'anticipation et de la joie</p>
                </div>
                <div className="text-center">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-white font-bold text-lg">3</span>
                  </div>
                  <h4 className="text-2xl font-bold mb-3 text-black">Rechoisir de nouvelles activités</h4>
                  <p className="text-green-600 font-medium h-16 flex items-center justify-center">Dès que toutes les activités sélectionnées sont livrées pour maintenir la surprise</p>
                </div>
              </div>
              <div className="text-center">
                <a href="/activites">
                  <Button size="lg" className="bg-primary hover:bg-primary/90">
                    Voir les activités
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </a>
              </div>
            </Card>
          </div>

          {/* Deux parcours */}
          <div className="grid md:grid-cols-2 gap-6 mb-12 max-w-3xl mx-auto">
            <Card className="p-8 shadow-warm border-2 border-primary/20 hover:border-primary/40 transition-colors cursor-pointer text-center">
              <div className="text-5xl md:text-6xl font-bold text-primary mb-2">29,50€</div>
              <div className="text-xl text-primary/80 mb-6">/mois</div>
              <h3 className="text-xl font-semibold mb-4 text-primary">Je compose ma box</h3>
              <p className="text-muted-foreground mb-6">
                Sélectionnez vous-même dans notre catalogue les activités qui plairont à votre grand-parent
              </p>
              <a href="/activites">
                <Button className="w-full bg-primary hover:bg-primary/90" size="lg">
                  Voir les activités
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </a>
            </Card>

            <Card className="p-8 shadow-warm border-2 border-warm-brown/20 hover:border-warm-brown/40 transition-colors cursor-pointer text-center">
              <div className="text-5xl md:text-6xl font-bold text-warm-brown mb-2">29,50€</div>
              <div className="text-xl text-warm-brown/80 mb-6">/mois</div>
              <h3 className="text-xl font-semibold mb-4 text-warm-brown">Je laisse Yumeli choisir</h3>
              <p className="text-muted-foreground mb-6">
                Décrivez-nous votre grand-parent et nous sélectionnerons les activités parfaites pour lui
              </p>
              <a href="/commande?mode=curated">
                <Button variant="outline" className="w-full border-warm-brown text-warm-brown hover:bg-warm-brown hover:text-white" size="lg">
                  S'abonner maintenant
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </a>
            </Card>
          </div>

          {/* Valeurs ajoutées */}
          <div className="p-8 mb-12 rounded-2xl bg-orange-50">
            <h3 className="text-2xl font-serif font-semibold mb-6 text-foreground">
              Pourquoi choisir Yumeli ?
            </h3>
            <div className="grid md:grid-cols-3 gap-6 text-left">
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h4 className="font-semibold mb-2 text-primary text-center">Personnalisation unique</h4>
                <p className="text-muted-foreground text-center">Le prénom de votre grand-parent est écrit dans chaque box pour un effet personnel touchant</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h4 className="font-semibold mb-2 text-primary text-center">Activités stimulantes</h4>
                <p className="text-muted-foreground text-center">Conçues pour stimuler la créativité, l'utilité quotidienne et les souvenirs précieux</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <h4 className="font-semibold mb-2 text-primary text-center">Sans engagement</h4>
                <p className="text-muted-foreground text-center">Abonnement sans engagement, résiliable à tout moment en quelques clics depuis votre espace client</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
};
export default Hero;